import { Link } from 'react-router-dom';
import { ROUTES } from '@core/config/constants';
import './Footer.css';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          {/* About Section */}
          <div className="footer__section">
            <h3 className="footer__title">About Us</h3>
            <p className="footer__text">
              AR Boutique is your premier destination for quality products. We offer the best selection
              of fashion, accessories, and lifestyle products.
            </p>
            <div className="footer__social">
              <a href="https://www.instagram.com/anusha_arboutique/" target="_blank" rel="noopener noreferrer" className="footer__social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer__section">
            <h3 className="footer__title">Quick Links</h3>
            <ul className="footer__list">
              <li>
                <Link to={ROUTES.HOME} className="footer__link">Home</Link>
              </li>
              <li>
                <Link to={ROUTES.PRODUCTS} className="footer__link">Shop</Link>
              </li>
              <li>
                <Link to={ROUTES.CATEGORIES} className="footer__link">Categories</Link>
              </li>
              <li>
                <Link to={ROUTES.CART} className="footer__link">Shopping Cart</Link>
              </li>
              <li>
                <Link to={ROUTES.ORDERS} className="footer__link">My Orders</Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="footer__section">
            <h3 className="footer__title">Customer Service</h3>
            <ul className="footer__list">
              <li>
                <Link to={ROUTES.CONTACT} className="footer__link">Contact Us</Link>
              </li>
              <li>
                <Link to={ROUTES.FAQ} className="footer__link">FAQ</Link>
              </li>
              <li>
                <Link to={ROUTES.SHIPPING} className="footer__link">Shipping Info</Link>
              </li>
              <li>
                <Link to={ROUTES.RETURNS} className="footer__link">Returns</Link>
              </li>
              <li>
                <Link to={ROUTES.PRIVACY} className="footer__link">Privacy Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer__section">
            <h3 className="footer__title">Contact Info</h3>
            <ul className="footer__list footer__list--contact">
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>36/1, Court Rd, Nagercoil, Tamil Nadu 629001</span>
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>+91 883 826 7429</span>
              </li>
              <li>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <span>anushamua@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; 2024 AR Boutique. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

